import type { StepGroup } from '../types/application';

export const journeyStages = [
  { id: 'application', label: 'Application', detail: 'Tell us about you, your home, and your finances.' },
  { id: 'credit', label: 'Credit', detail: 'Authorize a credit check so we can price your loan.' },
  { id: 'options', label: 'Loan options', detail: 'Choose the loan that fits your budget.' },
  { id: 'documents', label: 'Documents', detail: 'Upload the few documents we need.' },
  { id: 'processing', label: 'Processing', detail: 'We handle the rest and keep you updated.' },
];

export const stepGroups: StepGroup[] = [
  {
    id: 'property',
    label: 'Property',
    steps: [
      { id: 'goal', label: 'Your goal' },
      { id: 'stage', label: 'Where you are' },
      { id: 'type', label: 'Property type' },
      { id: 'use', label: 'How you’ll use it' },
      { id: 'price', label: 'Price & down payment' },
      { id: 'address', label: 'Property address' },
    ],
  },
  {
    id: 'about',
    label: 'About you',
    steps: [
      { id: 'name', label: 'Legal name' },
      { id: 'contact', label: 'Contact & identity' },
      { id: 'status', label: 'Marital & citizenship' },
      { id: 'home', label: 'Current address' },
      { id: 'housing', label: 'Housing' },
    ],
  },
  {
    id: 'income',
    label: 'Income',
    steps: [
      { id: 'employment', label: 'Employment type' },
      { id: 'employer', label: 'Employers' },
      { id: 'pay', label: 'Pay' },
      { id: 'other-income', label: 'Other income' },
    ],
  },
  {
    id: 'assets',
    label: 'Assets & debts',
    steps: [
      { id: 'accounts', label: 'Accounts' },
      { id: 'real-estate', label: 'Other properties' },
      { id: 'debts', label: 'Debts' },
    ],
  },
  {
    id: 'declarations',
    label: 'Declarations',
    steps: [
      { id: 'decl-property', label: 'This property' },
      { id: 'decl-transaction', label: 'This purchase' },
      { id: 'decl-history', label: 'Financial history' },
      { id: 'demographics', label: 'Demographics' },
    ],
  },
  {
    id: 'review',
    label: 'Review',
    steps: [{ id: 'review', label: 'Review application' }],
  },
];

export const minutesPerStep = 1;
